import type { Action, Transfer } from '@0xtorch/core'
import { createAction } from '../generators/createAction'
import { createTokenTransfer } from '../generators/createTokenTransfer'
import type { SolanaConverterArgs } from '../type'

export const unstake = (args: SolanaConverterArgs): Action[] | undefined => {
  const { transaction, source, relatedAddresses } = args

  // Extract transfers from the transaction
  const transfers: Transfer[] = []

  // Process token transfers from instructions (includes native SOL transfers)
  if (transaction.tokenTransfersFromInstructions) {
    for (const tokenTransfer of transaction.tokenTransfersFromInstructions) {
      const transfer = createTokenTransfer({
        tokenTransfer,
        relatedAddresses,
      })
      if (transfer) {
        transfers.push(transfer)
      }
    }
  }

  // Process token transfers from balances
  if (transaction.tokenTransfersFromBalances) {
    for (const tokenTransfer of transaction.tokenTransfersFromBalances) {
      const transfer = createTokenTransfer({
        tokenTransfer,
        relatedAddresses,
      })
      if (transfer) {
        transfers.push(transfer)
      }
    }
  }

  const action = createAction({
    type: 'unstake',
    transfers,
    transaction,
    source,
  })

  return [action]
}
